import {EmailIntegrationStates} from "../../States";

/**
 * update user handler
 * @param payload
 * @returns {*}
 */
export function UpdateEmailIntegration(payload) {
  if (payload)
    localStorage.setItem("nylasAccountInfo", JSON.stringify(payload));
  else localStorage.removeItem("nylasAccountInfo");

  if (payload)
    return {
      type: EmailIntegrationStates.SUCCESS,
      payload,
    };

  return {
    type: EmailIntegrationStates.DELETE,
    payload,
  };
}
